import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-carnet-backoffice',
  templateUrl: './aggiungi-carnet-backoffice.component.html',
  styleUrl: './aggiungi-carnet-backoffice.component.css'
})
export class AggiungiCarnetBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  formCarnet!: FormGroup;

  carnet_items: number[] = [0]

  ngOnInit(): void {

    this.formCarnet = new FormGroup({})

    this.carnet_items.map((contenuto, index) => {
      this.formCarnet.addControl('titolo_' + index, new FormControl(null, Validators.required))
      this.formCarnet.addControl('descrizione_' + index, new FormControl(null))
    })

  }

  onAddItem() {

    this.carnet_items.push(0)

    this.carnet_items.map((contenuto, index) => {
      this.formCarnet.addControl('titolo_' + index, new FormControl(null, Validators.required))
      this.formCarnet.addControl('descrizione_' + index, new FormControl(null))
    })

  }

  onRemoveItem(index: number) {
    this.carnet_items.splice(index, 1);

    this.formCarnet.removeControl('titolo_' + index)
    this.formCarnet.removeControl('descrizione_' + index)
  }

  onSubmit() {

    let carnet: any = {
      items: []
    }

    this.carnet_items.map((number, index) => {

      const titolo = this.formCarnet.get('titolo_' + index)?.value || '';
      const descrizione = this.formCarnet.get('descrizione_' + index)?.value || '';

      carnet.items.push({titolo: titolo, descrizione: descrizione});

    })

    this.apiService.addCarnet(carnet).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.setCarnets();
        this.apiService.message('success', 'Successo', 'Il carnet è stato aggiunto con successo!');
        this.router.navigate(['/backoffice/carnet'])
      }
    })

  }

}